import { IStoreEntityStateSlice, createEntitySlice, IStoreListStateSlice, createListSlice } from '@aston/foundation';
import { ISubsidiaryDetail, ISubsidiaryForm } from 'apps/console/src/app/subsidiaries-module/models';
import { IFilter } from '@aston/foundation';
import { IUsersList, UsersListSortProp, UserRole, UserStatus, ISubsidiaryAppliedUserDelegations, ISubsidiaryFormUserDelegations, ISubsidiaryFormUserInactivity } from '@aston/middle-users-admin';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

export interface ISubsidiaryDetailState {
	activeModal: NgbModalRef;
	currentSubsidiaryId: number;
	currentSubsidiary: IStoreEntityStateSlice<ISubsidiaryDetail>;
	subsidiaryForm: IStoreEntityStateSlice<ISubsidiaryForm>;
	subsidiaryFormIsEditing: boolean;
	usersList: IStoreListStateSlice<IUsersList, UsersListSortProp, IFilter>;
	availableRolesForCurrentSubsidiary: IStoreEntityStateSlice<UserRole[]>;
	transientUserStatus: IStoreEntityStateSlice<UserStatus>;
	transientSubsidiaryRole: IStoreEntityStateSlice<UserRole>;
	subsidiaryUserDelegations: IStoreEntityStateSlice<ISubsidiaryAppliedUserDelegations>;
	subsidiaryUserDelegationsForm: IStoreEntityStateSlice<ISubsidiaryFormUserDelegations>;
	subsidiaryUserInactivityForm: IStoreEntityStateSlice<ISubsidiaryFormUserInactivity>;
}

export const initialState: ISubsidiaryDetailState = {
	activeModal: null,
	currentSubsidiaryId: null,
	currentSubsidiary: createEntitySlice(),
	subsidiaryForm: createEntitySlice(),
	subsidiaryFormIsEditing: false,
	usersList: createListSlice({ prop: UsersListSortProp.FIRSTNAME, isDesc: false }),
	availableRolesForCurrentSubsidiary: null,
	transientUserStatus: createEntitySlice(),
	transientSubsidiaryRole: createEntitySlice(),
	subsidiaryUserDelegations: createEntitySlice(),
	subsidiaryUserDelegationsForm: createEntitySlice(),
	subsidiaryUserInactivityForm: createEntitySlice(),
};
